// The global chat bar tells the agent which page you asked from by prefixing
// the first message of a conversation with this marker. It is for the agent
// only — strip it wherever a stored message or chat title is shown to the user.
const AREA_CONTEXT_RE = /^\s*\[User is currently viewing: [^\]\n]*\]\s*/;

export const withAreaContext = (text: string, areaName: string): string =>
  `[User is currently viewing: ${areaName}]\n\n${text}`;

export const stripAreaContext = (text: string): string =>
  (text || '').replace(AREA_CONTEXT_RE, '');
